import styled from 'styled-components';
import { UserPresence } from '../UserPresence';

const Avatar = styled.div<{
  $hideInitials?: boolean;
  $size?: number;
  $fontSize?: number;
  $isInactive?: boolean;
}>`
  min-width: ${({ $size = 32 }) => $size}px;
  width: ${({ $size = 32 }) => $size}px;
  height: ${({ $size = 32 }) => $size}px;
  position: relative;
  border: 1px solid
    ${({ theme, $isInactive }) =>
      $isInactive ? theme.colors.border : theme.colors.text};
  border-radius: 100%;
  background: ${({ theme, $isInactive }) =>
    $isInactive ? theme.colors.border : theme.colors.text};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ $fontSize = 11 }) => $fontSize}px;
  color: ${({ theme, $isInactive }) =>
    $isInactive ? theme.colors.text : theme.colors.base};

  ${({ $hideInitials }) =>
    $hideInitials &&
    `
      background: none;
      border: none;
  `}
`;
const StyledUserPresence = styled(UserPresence)<{ $hideInitials?: boolean }>`
  ${({ $hideInitials }) =>
    $hideInitials &&
    `
    position: static;
    display: flex;
  `}
`;

const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 100%;
  overflow: hidden;
`;
const Image = styled.img`
  width: 100%;
  height: 100%;
  max-width: 100% !important;
  max-height: 100% !important;
  object-fit: cover;
`;
const Initials = styled.span``;

const GroupImage = styled.img<{ $size?: number }>`
  ${({ $size }) =>
    $size &&
    `
      height: ${$size}px;
      width: ${$size}px;
    `}
  max-height: 100%;

  > svg {
    height: 100%;
    width: 100%;
    color: ${({ theme }) => theme.colors.secondary};
    background: ${({ theme }) => theme.colors.primary};
  }
`;

export const Styled = {
  Avatar,
  UserPresence: StyledUserPresence,
  Initials,
  ImageWrapper,
  Image,
  GroupImage,
};
